/**
 * Wrapper for react-router-dom Link for consistent styling.
 */

import {
  TEAL_500,
  TEAL_600,
  THEME,
} from '@wandb/weave/common/css/globals.styles';
import React from 'react';
import {Link as LinkComp} from 'react-router-dom';
import styled from 'styled-components';

import {urlPrefixed} from '../../config';

export const Link = styled(LinkComp)`
  font-weight: 600;
  color: light-dark(${TEAL_600}, ${THEME.textLink});
  &:hover {
    color: light-dark(${TEAL_500}, ${THEME.accentHover});
  }
`;

const A = styled.a`
  font-weight: 600;
  color: light-dark(${TEAL_600}, ${THEME.textLink});
  &:hover {
    color: light-dark(${TEAL_500}, ${THEME.accentHover});
  }
`;

// Code duplication with @wandb/weave/common/util/links
export const TargetBlank = React.memo(
  React.forwardRef<
    HTMLAnchorElement,
    React.AnchorHTMLAttributes<HTMLAnchorElement>
  >(({children, ...passthroughProps}, ref) => {
    // Enforce an absolute prefixed url for blank targets
    if (
      passthroughProps.href != null &&
      !passthroughProps.href.startsWith('http')
    ) {
      passthroughProps.href = urlPrefixed(passthroughProps.href);
    }
    return (
      <A
        target="_blank"
        rel="noopener noreferrer"
        {...passthroughProps}
        ref={ref}>
        {children}
      </A>
    );
  })
);
